/** Synchronous in-flight guard for checkout API submission (trigger layer only). */
export function tryAcquireCheckoutRequest(hasStartedRef) {
  if (hasStartedRef.current) return false;
  hasStartedRef.current = true;
  return true;
}

export function releaseCheckoutRequest(hasStartedRef) {
  hasStartedRef.current = false;
}

export function isCheckoutRequestInFlight(hasStartedRef) {
  return Boolean(hasStartedRef.current);
}
